import gsap from "gsap";
import CSSPlugin from "gsap/CSSPlugin";
import { $, $all, once, listenResize, forEach } from "@olmokit/dom";
import Lazy from "@olmokit/core/lazy";
import ajax from "@olmokit/core/ajax";
import dialog from "@olmokit/core/dialog";
import { breakpoints } from "@olmokit/core/scss";
import "@olmokit/core/dialog/async/index.scss";
import { Storefinder } from "components/Storefinder";
import productMosaicsSlider from "components/Product/mosaics";
import loadSizesImages from "components/Product/sizes";
import { navigateBackToCollection } from "components/Product";
import { getCollectionClickData } from "utils/trackCollectionLinks";
import { globalConf } from "@olmokit/core/data";
import trackCollectionView from "utils/trackCollectionView";
import { post } from "@olmokit/core/fragments/ajax";
import { getDataAttr } from "@olmokit/dom";
import "./index.scss";

/**
 * Dialog product
 */
const $html = $("html");
const $header = $(".Header:");

const ATTR_COLLECTION_SLUG = "collection-slug";
const ATTR_PRODUCT_SLUG = "product-slug";

let headerVisible = false;

const dialogProduct = dialog(
  "#DialogProduct",
  {
    id: "product"
  },
  {
    /**
     * Mounted is called when we are in the single product page and the product
     * data and DOM had populated the dialog content server side, so we need to
     * calculate the Sizes images dimensions and do some intialization both here
     * and in the render method called when we dynamically update the dialog
     * content.
     */
    mounted: dialog => {
      // apply lazy load only to the sizes images, because on page load Lazy
      // already auto init on all the rest...
      loadSizesImages(".Productdialog:body", container => {
        dialog.loaded();
        new Lazy({ container }).loadAll();
      });

      // on mounted if we have content it means that we are landed on the single
      // product page, in this scenario we need to do some tracking
      const $productCloseLink = $(".Productdialog:head__close", dialog.$content);

      if ($productCloseLink) {
        // flag the dialog as opened (on load it is opened by default...)

        once(document, "dialog.closing", () => {
          const data = getCollectionClickData($productCloseLink);
          dataLayer.push(data);
        });

        once(document, "dialog.closed", () => {
          trackCollectionView();
        });

        // we also need to initialise the storefinder and the mosaics
        Storefinder(dialog.$root).init();
        dialog._sliderM = productMosaicsSlider(dialog.$root);
        showHeader();
        // $html.classList.add("is-dialogproduct-open");
      }
    },
    rendered: dialog => {
      loadSizesImages(".Productdialog:body", () => {
        dialog.loaded();

        new Lazy({ container: dialog.$content });
      });

      dialog._sliderM = productMosaicsSlider(dialog.$content);

      Storefinder(dialog.$content).init();
    },
    opening: dialog => {
      dialog.isOpen = true;
      maybeToggleHeader();
      $html.classList.add("is-dialogproduct-open");
    },
    // Unless called with a true second argument it will ...?
    closing: (dialog, avoidRedirect) => {
      if (!avoidRedirect) {
        navigateBackToCollection();
      }
    },
    closed: dialog => {
      dialog.isOpen = false;
      hideHeader();

      // the slider might not be there if the product has no mosaics or other
      // weird race conditions in navigation
      try {
        dialog._sliderM.destroy();
      } catch (e) {}

      $html.classList.remove("is-dialogproduct-open");
    }
  }
);

gsap.registerPlugin(CSSPlugin);

/** Show header on top of dialog on small screens */
function maybeToggleHeader() {
  if (!dialogProduct.isOpen) return;
  if (innerWidth < breakpoints.md) {
    showHeader();
  } else {
    hideHeader();
  }
}

function showHeader() {
  if (headerVisible) return;
  gsap.set($header, { position: "fixed", yPercent: -100 });
  gsap.to($header, {
    yPercent: 0,
    onComplete: () => {
      headerVisible = true;
    }
  });
}

function hideHeader() {
  if (!headerVisible) return;
  gsap.to($header, {
    yPercent: -100,
    onComplete: () => {
      gsap.set($header, { position: "absolute", yPercent: 0 });
      headerVisible = false;
    }
  });
}

// listen on resize too and toggle header accordingly
listenResize(maybeToggleHeader);

const templatesMap = {};

/**
 * Goto (dialog decorator), uses cached template if any and cache ajax requests
 * Trigger dialog.open before after render if the template is cached, otherwise
 *
 * @override
 * @param {string} productSlug
 */
dialogProduct.goto = function(productSlug) {
  const dialog = dialogProduct;
  dialog.current = productSlug;
  $html.classList.remove("page-singleproduct");
  dialog.render("", true);
  dialog.load();

  let collectionSlug = ''

  const $products = $all('.product:.glide__slide');
  forEach($products, (product) => {
    console.log('ATTR_PRODUCT_SLUG', product.getAttribute(`data-${ATTR_PRODUCT_SLUG}`));
    if(product.getAttribute(`data-${ATTR_PRODUCT_SLUG}`) == productSlug) {
      collectionSlug = product.getAttribute(`data-${ATTR_COLLECTION_SLUG}`)
    }
  });

  if (templatesMap[productSlug]) {
    dialog.render(templatesMap[productSlug]);
    dialog.open();
  } else {
    dialog.open();

    post('product', {
      data: {
        slug: productSlug,
        folder: collectionSlug,
      },
    }).then(({ data }) => {
      const $root = $('#DialogProduct');
      const $products = $('.dialogContent', $root);
      $products.innerHTML = data;

      const $roots = $('.Store:img');
      Storefinder($roots).init();
    });

    // ajax(globalConf.cmsApiUrl + `/en/porcelain-tile-collections/cove/${productSlug}`, { cacheKey: productSlug }).then(
    //   ({ data }) => {
    //     templatesMap[productSlug] = data;
    //     console.log(templatesMap[productSlug])

    //     if (productSlug === dialog.current) {
    //       dialog.render(templatesMap[productSlug]);
    //     }
    //   }
    // );
  }
};

/**
 * Goaway (dialog decorator) close the dialog without history redirect
 */
dialogProduct.goaway = function() {
  dialogProduct.close(null, true);
};

export default dialogProduct;
